<div class="aside_title-section">
  <h1 class="title-dashboard">{{ 'POI.POI_TO_VALIDATE' | translate }}</h1>
</div>
@if (permissionService.checkPermissionValue({ permission: 'READ', tab: 'poi' })) {
  <div class="widget-content-height">
    @if ($landmarks(); as landmarks) {
      @if (landmarks?.length > 0) {
        @for (landmark of landmarks | slice: 0 : 5; track landmark; let index = $index) {
          <landmark-card
            style="cursor: pointer"
            [landmark]="landmark"
            (click)="navigateToLandmark(landmark.uid, landmark.uid_parent)" />
        }
      } @else {
        <div class="missing-data-dashboard">
          <p>{{ 'POI.NO_POI_TO_VALIDATE' | translate }}</p>
        </div>
      }
      @if (landmarks?.length > 5) {
        <div class="data-more-icon">
          <mat-icon [routerLink]="[LANDMARKS_VALIDATE]" [matTooltip]="'COMMON.SEEMORE' | translate">
            more_horiz
          </mat-icon>
        </div>
      }
    } @else {
      <widget-loader />
    }
  </div>
} @else {
  <p class="not-allowed-text">
    {{ 'USER.NOT_ACCESS_DATA' | translate }}
    <br />
    {{ 'USER.PLEASECONTACTADMIN' | translate }}
  </p>
}
